<template>
  <div class="obituary-single__info-live-section">
    <h3 v-text="texts.infoHeading" />
    <ul class="check-list">
      <li v-if="!isLoading">
        {{ formatedStartTime }}
      </li>
      <li v-else class="skeleton-loader-text" />
      <li v-text="texts.infoDesc" />
    </ul>
    <button
      class="btn obituary"
      :disabled="isLoading"
      @click.prevent="toggleModal"
      v-text="texts.watchLiveHere"
    />

    <Modal
      v-if="!isLoading"
      :disabled="false"
      :modal-heading="texts.heading"
      :modal-open="modalOpen"
      :toggle-modal="toggleModal"
      :class-name="'obituary-single__live-modal'"
    >
      <transition name="modal-content" mode="out-in">
        <div class="obituary-single__section-wrapper">
          <div class="obituary-single__left-content">
            <div class="live-container">
              <iframe
                v-if="modalOpen"
                :src="iFrameEmbedURL"
                frameborder="0"
                allow="fullscreen"
              />
            </div>
          </div>
          <div class="obituary-single__right-content">
            <h3 v-text="texts.infoHeading" />
            <ul class="check-list">
              <li>{{ formatedStartTime }}</li>
              <li v-text="texts.infoVolume" />
              <li v-html="infoReload" />
              <li v-html="infoNewTab" />
            </ul>
          </div>
        </div>
      </transition>
    </Modal>
  </div>
</template>

<script>
import { sprintf } from 'sprintf-js';
import { format, parse } from 'date-fns';
import Modal from 'Components/Modal.vue';
import { mapState } from 'vuex';
import { useDateFormatter } from 'Composables/useDateFormatter';

export default {
  components: {
    Modal,
  },

  setup() {
    const { timeSinceDate, toValidDate, getLocale } = useDateFormatter();
    return { timeSinceDate, toValidDate, getLocale };
  },
  data() {
    // get the Live query parameter for all browsers except IE11.
    let live = false;
    if ('URLSearchParams' in window) {
      live = !!new URLSearchParams(window.location.search.substring(1)).get(
        'live'
      );
    }

    const { dataset } = this.$mountEl;

    return {
      id: dataset.orderId,
      modalOpen: !!live,
      texts: lavendlaObituary.live,
    };
  },

  computed: {
    ...mapState('orders', ['order', 'isLoading']),

    formatedStartTime() {
      if (!this.order || this.isLoading) {
        return null;
      }

      const locale = this.getLocale();
      const startDate = this.parse(
        this.order.ceremony.start_date,
        'yyyy-MM-dd H:m:s',
        new Date()
      );
      const endDate = this.parse(
        this.order.ceremony.end_date,
        'yyyy-MM-dd H:m:s',
        new Date()
      );
      const formatedDate =
        this.format(startDate, 'iiii d LLLL HH:mm', { locale: locale }) +
        ' - ' +
        this.format(endDate, 'HH:mm', { locale: locale });

      return formatedDate[0].toUpperCase() + formatedDate.substring(1);
    },

    iFrameEmbedURL() {
      if (!this.order || this.isLoading) {
        return null;
      }

      return this.order.memorialPage.live_url.replace(
        'rackfish.com/player/',
        'rackfish.com/embed/'
      );
    },

    infoReload() {
      return sprintf(
        this.texts.infoReload,
        `<a href="javascript:window.location.reload(true)">${this.texts.clickHere}</a>`
      );
    },

    infoNewTab() {
      if (!this.order || this.isLoading) {
        return null;
      }

      return sprintf(
        this.texts.infoNewTab,
        `<a target="_blank" href="${this.order.memorialPage.live_url}">${this.texts.infoNewTabLink}</a>`
      );
    },
  },

  created() {
    if (this.id && !this.order) {
      this.$store.dispatch('orders/getOrder', this.id);
    }
  },

  methods: {
    parse,
    format,
    sprintf,

    toggleModal() {
      if ('URLSearchParams' in window) {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('live')) {
          searchParams.delete('live');
        } else {
          searchParams.append('live', 'open');
        }
        window.history.replaceState(null, null, '?' + searchParams.toString());
      }
      this.modalOpen = !this.modalOpen;
    },
  },
};
</script>
